import moment from 'moment-timezone';
import { resolveTimezone } from './timeDisplaySettings'

const momenttz = (val, deviceTimeZone) => {
	const userTimeZone = resolveTimezone(deviceTimeZone) || Intl.DateTimeFormat().resolvedOptions().timeZone

	if (val && userTimeZone) {
		return moment.tz(val, userTimeZone)
	}

	if (val) {
		return moment(val)
	}

	if (userTimeZone) {
		return moment.tz(userTimeZone)
	}

	return moment()
}

export default momenttz
